"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "¿Cuánto tiempo toma producir una canción personalizada?",
  answer: "El proceso creativo varía según la complejidad del proyecto, pero generalmente entregamos una producción completa en un plazo de 2 a 3 semanas, asegurando la máxima calidad y profesionalismo en cada nota."
}, {
  question: "¿Soy el dueño de los derechos de la música que encargo?",
  answer: "Sí, para proyectos personalizados como cumpleaños o eventos especiales, tú conservas los derechos de uso. Para producciones comerciales o ministeriales, establecemos acuerdos claros de propiedad intelectual que protegen tu visión y legado."
}, {
  question: "¿Producen música en otros idiomas además del español?",
  answer: "Absolutamente. En Rolver Music Productions nos especializamos en producciones tanto en español como en inglés, permitiendo que tu mensaje de fe e inspiración trascienda fronteras culturales."
}, {
  question: "¿Qué necesito proporcionar para empezar mi proyecto?",
  answer: "Solo necesitamos tu idea, el propósito del proyecto y, si tienes, alguna referencia musical que te inspire. Nosotros nos encargamos de la composición, arreglos, grabación y masterización profesional."
}, {
  question: "¿Ofrecen servicios para empresas y proyectos especiales?",
  answer: "Sí, creamos identidades sonoras, himnos corporativos y música para eventos empresariales que transmiten los valores y la creatividad de tu marca con un sello de excelencia."
}];
export default function PreguntasFrecuentes() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221837" id="preguntas-frecuentes" className="bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-default font-bold tracking-wider mb-4 text-foreground">
            Preguntas Frecuentes
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-sans">
            Encuentra respuestas a las dudas comunes sobre cómo transformamos tus ideas en melodías inspiradoras en Rolver Music Productions.
          </p>
        </div>

        <div ref={ref} className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="bg-card/40 backdrop-blur-xl border border-border/30 rounded-2xl p-6 md:p-10 shadow-3xl">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/20 py-2">
                  <AccordionTrigger className="text-[20px] font-default font-semibold hover:no-underline text-left [&>svg]:text-primary [&>svg]:size-6 transition-colors hover:text-primary/80 tracking-tight">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground text-base leading-relaxed font-sans pt-2 pb-6">
                    <div className="animate-in fade-in slide-in-from-top-2 duration-500 ease-out">
                      {faq.answer}
                    </div>
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}